<template>
  <div v-if="$store.state.modal2" id="instruction">
    <div class="container">
      <v-dialog
        v-model="$store.state.modal2"
        persistent
        class="modal"
        full-width
      >
        <v-toolbar id="config-toolbar" color="blue" dark>
          <v-card-title class="text-xs-center headline">
            <v-icon>mdi-playlist-edit</v-icon>Instrucción de Riego
          </v-card-title>
          <v-spacer />

          <v-tooltip bottom z-index="99999">
            <template v-slot:activator="{ on }">
              <router-link to="/Ayuda">
                <div class>
                  <v-btn flat v-on="on">
                    <v-icon>mdi-help-circle-outline</v-icon>
                  </v-btn>
                </div>
              </router-link>
            </template>
            <span>Ayuda</span>
          </v-tooltip>
          <v-tooltip bottom z-index="99999">
            <template v-slot:activator="{ on }">
              <div>
                <v-btn flat v-on="on" @click="closeSave()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </template>
            <span>Cerrar</span>
          </v-tooltip>
        </v-toolbar>
        <v-card class="main">
          <!-- BUTTONS CONTROLS -->
          <div v-if="charts" class="historic-charts">
            <chart />
            <hr />
          </div>

          <!-- TABLE FOR IRRIGATION INSTRUCTION -->
          <div
            v-if="$store.state.pulsesHeaders"
            v-for="(item, index) in $store.state.splitIrrigationInstructions"
            class="time-table"
          >
            <v-layout row class="times-table">
              <v-flex lg5 md5 sm5 xs5>
                <h3 v-show="$store.state.userId != 22" class="text-xs-center">
                  {{ $store.state.subProject }}
                </h3>
                <v-data-table
                  v-if="
                    $store.state.splitIrrigationInstructions &&
                      $store.state.userId != 22
                  "
                  :headers="headers"
                  :items="$store.state.splitIrrigationInstructions[index]"
                  hide-actions
                  expand
                  header-length="40px"
                  class="elevation-1"
                >
                  <template v-slot:items="{ item }">
                    <td class="text-xs-center">{{ item.name }}</td>
                    <td class="text-xs-center">{{ item.sector }}</td>
                    <td class="text-xs-center">{{ item.head }}</td>
                    <td class="text-xs-center">{{ item.milliliters }}</td>
                    <td class="text-xs-center">{{ item.pH }}</td>
                    <td class="text-xs-right comment-container">
                      <div class="comment">{{ item.comments }}</div>
                    </td>
                  </template>
                </v-data-table>
                <v-data-table
                  v-if="$store.state.userId === 22"
                  :headers="headersDemo"
                  :items="$store.state.splitIrrigationInstructions[index]"
                  hide-actions
                  expand
                  header-length="40px"
                  class="elevation-1"
                >
                  <template v-slot:items="{ item }">
                    <!-- <td class="text-xs-center">{{ item.name }}</td> -->
                    <td class="text-xs-center">{{ item.sector }}</td>
                    <td class="text-xs-center">{{ item.head }}</td>
                    <td class="text-xs-center">{{ item.milliliters }}</td>
                    <td class="text-xs-center">{{ item.pH }}</td>
                    <td class="text-xs-right comment-container">
                      <div class="comment">{{ item.comments }}</div>
                    </td>
                  </template>
                </v-data-table>
                <div class="leyend">
                  <tr>
                    <td>
                      <strong>Hora de Inicio:</strong>
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td>
                      <strong>Hora Final:</strong>
                    </td>
                  </tr>
                </div>
              </v-flex>

              <!-- TABLAS DE PULSOS -->
              <v-flex lg9 md9 sm9 xs9 class="pulsesTable">
                <h3 v-show="$store.state.userId != 22" class="text-xs-center">
                  TABLA DE PULSOS
                </h3>
                <v-data-table
                  :headers="$store.state.pulsesHeaders[index]"
                  :items="$store.state.pulsesTable[index]"
                  hide-actions
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <template
                      v-for="(pulse, i) in $store.state.pulsesTable[index][0]"
                    >
                      <td v-if="props.item[i]" class="text-xs-center">
                        <strong>{{ props.item[i].minFormated }}</strong>
                      </td>
                      <td class="text-xs-center">
                        {{ props.item[i].electricConductivity }}
                      </td>
                    </template>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <br />
          </div>

          <div>
            <v-layout
              v-if="
                $store.state.userType === 'readWrite' ||
                  $store.state.userType === 'admin'
              "
              row
            >
              <v-flex lg6 md6 sm12 xs12>
                <v-btn class="config" round color="blue" dark @click="config">
                  <v-icon>mdi-settings</v-icon>CONFIGURAR GRUPO
                </v-btn>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-btn
                  class="config blue-grey lighten-3"
                  round
                  color="blue"
                  dark
                  @click="configPulse = true"
                >
                  <v-icon>mdi-settings</v-icon>CONFIGURAR CE POR SECTOR DE RIEGO
                </v-btn>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12 />
              <v-flex>
                <v-btn
                  class="save"
                  round
                  color="light-green lighten-1"
                  dark
                  @click="submit"
                >
                  <v-icon>mdi-content-save-outline</v-icon>GUARDAR
                </v-btn>
              </v-flex>
              <v-flex>
                <v-btn
                  class="save"
                  round
                  color="light-blue darken-3"
                  dark
                  flat
                  @click="pdf"
                >
                  <v-icon>mdi-file-pdf-box</v-icon>DESCARGAR PDF
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </v-card>

        <!-- MODAL PARA GUARAR  -->
        <v-dialog v-model="dialog" max-width="600" padding="50">
          <v-card>
            <v-toolbar color="orange" dark>
              <v-card-title class="text-xs-center headline">
                <v-icon>mdi-alert-circle-outline</v-icon>ANTES DE GUARDAR
              </v-card-title>
              <v-spacer />
            </v-toolbar>

            <v-card-text class="text-xs-center">
              <h3>¿Cómo deseas guardar la Instrucción de Riego?</h3>
            </v-card-text>

            <v-card-actions>
              <v-spacer />

              <v-btn round color="blue" @click="closeSave">TEMPLATE</v-btn>

              <v-btn round color="light-green lighten-1" @click="closeSave"
                >DÍA</v-btn
              >
            </v-card-actions>
            <br />
          </v-card>
        </v-dialog>
        <pulse ref="pulseTable" v-if="$store.state.modal3" />

        <!-- MODAL TO CHANGE CE BY PULSE -->
        <v-dialog v-model="configPulse" max-width="800" height="200">
          <v-card>
            <v-toolbar color="blue" dark>
              <v-card-title class="text-xs-center headline">
                <v-icon>mdi-settings</v-icon>Configuración CE por Sector de
                Riego
              </v-card-title>
              <v-spacer />
            </v-toolbar>

            <div class="pulse-config">
              <v-layout>
                <!-- <v-select
                  v-model="select"
                  :items="$store.state.splitIrrigationInstructions[0]"
                  item-text="name"
                  item-value="select"
                  class="dropdown"
                  @change="selectAgroUnit"
                  label="Sector de Riego"
                />-->
                <v-select
                  v-model="select"
                  :items="$store.state.irrigationInstructions"
                  item-text="name"
                  class="dropdown"
                  @input="selectAgroUnit(select)"
                  label="Sector de Riego"
                />
              </v-layout>
              <div v-if="select">
                <v-layout row wrap>
                  <v-flex xs5 sm5 md5 lg5>
                    <br />
                    <thead>
                      <tr>
                        <th class="head text-xs-center">No.</th>
                        <th class="head text-xs-center">CE</th>
                      </tr>
                    </thead>
                    <!-- <tr v-for="(pulse, k) in $store.state.splitPulses[1][index]" :key="k"> -->
                    <tr
                      v-for="(pulse, k) in $store.state.pulses[index]"
                      :key="k"
                    >
                      <td>{{ k + 1 }}</td>
                      <td class="tablebox">
                        <input
                          v-model="pulse.electricConductivity"
                          class="text-xs-center agro-unit"
                          type="number"
                          step="0.1"
                        />
                      </td>
                    </tr>
                  </v-flex>

                  <v-flex xs5 sm5 md5 lg5>
                    <br />
                    <div class="modify-all elevation-1">
                      <h4
                        color="blue"
                        @click="clickedAllModal"
                        class="ce-modal"
                      >
                        Modificar todos por Sector...
                        <v-icon color="blue">mdi-pencil</v-icon>
                      </h4>
                      <v-layout v-if="allModal">
                        <input
                          large
                          v-model="totalCE"
                          class="text-xs-center inputCE"
                          type="number"
                          step="0.1"
                        />

                        <v-btn
                          class="update"
                          color="blue"
                          round
                          large
                          @click="updateAll(index)"
                          >Actualizar</v-btn
                        >
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
              <v-layout row>
                <v-flex xs12 sm12 md12 lg12>
                  <v-layout row>
                    <v-btn
                      v-if="select"
                      class="accept-pulse"
                      round
                      block
                      right
                      color="light-green lighten-1"
                      dark
                      @click="sendPulse"
                    >
                      <v-icon>mdi-content-save-outline</v-icon>GUARDAR
                    </v-btn>
                    <!-- <v-btn class="save" round color="light-green lighten-1" dark @click="sendPulse">
                      <v-icon>mdi-content-save-outline</v-icon>GUARDAR
                    </v-btn>-->
                    <br />
                  </v-layout>
                  <br />
                  <p class="text-xs-center">
                    *Recuerda solo guardar despues de haber realizado todos los
                    cambios!
                  </p>
                </v-flex>
              </v-layout>
            </div>
            <br />
          </v-card>
        </v-dialog>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import Pulse from "./PulseTable.vue";
import Chart from "./HistoricalCharts.vue";
import axiosApi from "../../axios-api";

export default {
  components: {
    Pulse,
    Chart,
  },
  data() {
    return {
      totalCE: 1,
      allModal: false,
      newInstructions: null,
      newPulses: null,
      dialog: false,
      configPulse: false,
      pulseInfo: null,
      select: null,
      index: 0,
      date: new Date().toISOString().substr(0, 10),
      yesterdayReports: false,
      charts: false,
      headers: [
        { text: "Nombre del Sector" },
        { text: "No. Sector" },
        { text: "Cabezal" },
        { text: "ml" },
        { text: "pH" },
        { text: "Comentarios" },
      ],
      headersDemo: [
        // { text: "Nombre del Sector" },
        { text: "No. Sector" },
        { text: "Cabezal" },
        { text: "ml" },
        { text: "pH" },
        { text: "Comentarios" },
      ],
      headersYestarday: [
        { text: "Nave", sortable: true, value: "nave" },
        { text: "Sector", value: "sector", sortable: false },
        { text: "CE Gotero", value: "CE Gotero", sortable: false },
        { text: "CE Drenaje", value: "CE Drenaje", sortable: false },
        { text: "pH Goter", value: "pH Gotero", sortable: false },
        { text: "pH Drenaje", value: "pH Drenaje", sortable: false },
      ],
      headersYestarday2: [
        {
          text: "Nave",
          sortable: true,
          value: "nave",
          align: " d-none",
        },
        { text: "Riego Netajet", value: "netajet" },
        { text: "Riego Total", value: "total" },
        { text: "mg Na Riego", value: "mg Na riego" },
        { text: "mg Na Drenaje", value: "mg Na drenaje" },
        { text: "Balance", value: "balance" },
        { text: "Drenaje", value: "drenaje" },
      ],
      headers3: [
        { text: "Nave", value: "nave", align: " d-none" },
        {
          text: "D. Anterior.",
          child: ["December"],
          value: "% Drenaje del Dia anterior",
        },
      ],
      initialTimes: [null, null],
      items: [],
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
      },
    };
  },
  computed: {
    rancho() {
      return this.$store.getters.subProject;
    },
    pulses() {
      return this.$store.getters.pulses;
    },
  },
  watch: {
    rancho() {
      this.arr = [];
    },
    pulse() {
      this.newPulses = [];
    },
  },
  created() {},
  beforeMount() {
    // console.log("BEFORE MOUNTED");
    this.createTable();
  },
  updated() {
    // console.log("updated!");
  },
  methods: {
    createTable() {},
    moment: function(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },
    config() {
      this.$store.commit("modal3", true);
    },
    closeSave() {
      this.$store.commit("modal2", false);
      this.dialog = false;
    },
    updateAll(index) {
      // alert(`${this.totalCE}  index:${index}`);
      this.$store.state.pulses[index].forEach((element) => {
        // console.log("El", element);
        element.electricConductivity = this.totalCE;
      });
    },
    clickedAllModal() {
      this.allModal = !this.allModal;
    },
    selectAgroUnit(select) {
      // this.totalCE = 1;
      // console.log("select", select);
      let index = this.$store.state.irrigationInstructions.findIndex(
        (x) => x.name === select
      );
      this.index = index;
    },
    sendPulse() {
      this.$store.commit("modal3", false);
      this.$store.commit("modal2", false);
      this.configPulse = false;
      this.submit();
    },
    submit: async function() {
      // console.log("Pu", this.$store.state.pulses);
      // console.log("Pu", this.$store.state.splitPulses);
      let z = confirm("¿Estas seguro?");
      if (z == true) {
        let startDate = moment(new Date()).format("YYYY-MM-DD");
        let endDate = moment()
          .add(1, "days")
          .format("YYYY-MM-DD");

        let irrigationInstructionsBySubproyect = (
          await axiosApi.get(
            `/irrigation-instruction/get-all-by-subproject/${this.$store.state.subProjectId}?startDate=${startDate}&endDate=${endDate}`
          )
        ).data;

        if (this.$store.state.splitIrrigationInstructions.length > 1) {
          // console.log("More than 1 head");
          this.newInstructions = [
            ...this.$store.state.splitIrrigationInstructions[0].slice(0, -2),
          ].concat(
            [...this.$store.state.splitIrrigationInstructions[1]].slice(0, -2)
          );
          this.newPulses = [...this.$store.state.splitPulses[0]].concat([
            ...this.$store.state.splitPulses[1],
          ]);
        } else {
          // console.log("1 head");
          this.newInstructions = [
            ...this.$store.state.splitIrrigationInstructions[0].slice(0, -2),
          ];
          this.newPulses = [...this.$store.state.splitPulses[0]];
        }

        this.newPulses = JSON.parse(JSON.stringify(this.newPulses));

        // IF NO INSTRUCTIONS THAT DAY
        if (irrigationInstructionsBySubproyect.length === 0) {
          // console.log("Zzzzz", this.newInstructions);
          this.submitReport = (
            await axiosApi.post(
              `/irrigation-instruction/insert-irrigation-instructions/`,
              this.newInstructions
            )
          ).data;

          // console.log(this.submitReport);

          this.submitReport.map((element, index) => {
            // console.log("element", element.id);
            let irrigationInstructionId = element.id;
            // console.log(irrigationInstructionId);

            this.newPulses[index].map((x) => {
              // console.log("Insert Pulse", x, x.id);
              x.electricConductivity = parseFloat(x.electricConductivity);
              x.irrigationInstructionId = irrigationInstructionId;
            });
          });

          // console.log(".....", this.submitReport);
          // console.log(".....", this.newPulses);

          this.newPulses.map((pulseArr) => {
            this.submitPulses = axiosApi
              .post(`/pulse-instruction/insert-pulse-instructions`, pulseArr)
              .then((response) => {
                // console.log("pulse resp", response);
                this.res = response.data;
              });
          });
          this.$store.commit("modal2", false);
        } else {
          // IF THERE IS INSTRUCTIONS THAT DAY
          let test = confirm("¿Quieres sobre escribir la intruccion?");
          // DELETE TRUE
          if (test == true) {
            for (const indInst of irrigationInstructionsBySubproyect) {
              axiosApi.delete(
                `/irrigation-instruction/delete-by-id/${indInst.id}`
              );
            }

            // console.log("Zzzzz", this.newInstructions);
            this.submitReport = (
              await axiosApi.post(
                `/irrigation-instruction/insert-irrigation-instructions/`,
                this.newInstructions
              )
            ).data;
            // console.log(this.submitReport);

            this.submitReport.map((element, index) => {
              // console.log("element", element.id);
              let irrigationInstructionId = element.id;
              // console.log(irrigationInstructionId);
              this.newPulses[index].map((x) => {
                // console.log(x);
                // console.log("Insert Pulse", x, x.id);
                x.electricConductivity = parseFloat(x.electricConductivity);
                x.irrigationInstructionId = irrigationInstructionId;
              });
            });

            // console.log(">>>>>>>>", this.newPulses);

            this.newPulses.map((pulseArr) => {
              this.submitPulses = axiosApi
                .post(`/pulse-instruction/insert-pulse-instructions`, pulseArr)
                .then((response) => {
                  // console.log("pulse resp", response);
                  this.res = response.data;
                });
            });
            this.$store.commit("modal2", false);
          } else {
            alert("La instruccion no fue guardada!");
          }
        }
      } else {
        // text = "La instrucción no fue guardada!";
      }
    },
    pdf() {
      window.print();
    },
  },
};
</script>

<style scoped>
#config-toolbar {
  top: 15px;
  display: block;
  position: inherit !important;
  margin-bottom: 0px !important;
  z-index: 99999 !important;
}

.time-table {
  transform: scale(0.95);
  transform-origin: 0% 0% 0px;
}

.dot {
  height: 13px;
  width: 13px;
  background-color: lightgreen;
  border-radius: 50%;
  margin-right: 7px;
  display: inline-block;
}

.dot2 {
  height: 13px;
  width: 13px;
  background-color: red;
  border-radius: 50%;
  margin-right: 7px;
  display: inline-block;
}

table tr {
  line-height: 5px !important;
  max-height: 5px !important;
  height: 5px;
  overflow: hidden;
}

.leyend {
  position: absolute;
  display: inline;
  margin-top: -80px;
  margin-left: 300px;
}

.comment-container {
  width: 200px !important;
  max-width: 10px;
  height: 47px !important;
  max-height: 47px !important;
  padding: 0px !important;
  overflow: hidden;
  text-align: center;
  line-height: 14px;
}

.comment {
  padding: 5px;
  max-width: 100% !important;
  height: 47px !important;
  max-height: 47px !important;
  word-wrap: break-word;
  overflow-y: scroll;
  text-align: auto;
  margin: auto;
  display: flex;
  align-content: center;
  align-self: center;
  text-align: center;
}

.chartIcon {
  left: -5% !important;
}

.controlButtons {
  background-color: #e0e0e0;
}

.modal {
  z-index: 99999 !important;
}

.main {
  padding: 30px;
}

input {
  background-color: rgba(190, 190, 190, 0.1);
  display: block !important;
  border: 0.5px solid lightgray !important;
  border-radius: 3px;
  padding: 8px;
  width: 120px;
}

.config-pulse {
  top: 5px;
}

.pulse-config {
  padding-left: 100px;
  padding-right: 40px;
}

.accept-pulse {
  margin-left: 40%;
  margin-top: -30px;
  display: inline-block;
}

.historic-charts {
  margin-top: -7px;
}

.times-table {
  height: 100%;
}

.v-icon {
  margin-right: 7px !important;
}

.v-datatable {
  max-height: 10px !important;
}

.lock {
  opacity: 0.6;
  background-color: darkgrey;
}

.chart {
  width: 50%;
}

.config {
  width: 80%;
}

.save {
  width: 100%;
}

.control {
  width: 50px !important;
}

.close {
  display: inline !important;
  float: right;
}

.ce-modal {
  color: #2196f3 !important;
  cursor: pointer;
}

.modify-all {
  width: 360px;
  padding: 25px;
  border: 1px solid lightgray;
  border-radius: 3px;
  margin-bottom: 45px;
}

.update {
  margin-left: 8%;
  height: 50px !important;
}

@media only screen and (max-width: 900px) {
  .container {
    width: 100% !important;
    height: 50% !important;
    margin-left: 0 !important;
    background-color: white !important;
    zoom: 50% !important;
  }

  .card {
    padding-top: 50px !important;
    padding-bottom: 50px !important;
    background-color: white !important;
  }
}

@media only screen and (max-width: 600px) {
  .container {
    /* width: 100% !important;
    height: 70% !important; */
    zoom: 30% !important;
    margin-left: 0 !important;
    background-color: white !important;
  }

  .card {
    padding-top: 50px !important;
    padding-bottom: 50px !important;
    padding-left: 0px !important;
    background-color: white !important;
    /* zoom: 30% !important; */
  }
}
</style>
